export default __webpack_public_path__ + "static/media/banner1.f9281d53.jpg";